import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the settings state domain
 */

const selectSettingsDomain = state => state.settings || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Settings
 */

const selectSettingsList = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.settingsList,
  );

const selectSettingsLoading = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.loading,
  );

const selectSettingsError = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.error,
  );

export {
  selectSettingsDomain,
  selectSettingsLoading,
  selectSettingsError,
  selectSettingsList,
};
